// One BCP 47 tag `Intl` will actually take.
//
// This was `lang + '-' + lang.toUpperCase()` — `sk` -> `sk-SK`, which is what
// the eight shipped language codes need. The same line turns a tag that ALREADY
// names a region into `en-GB-EN-GB`, and `Intl.NumberFormat` THROWS a
// RangeError on a malformed tag rather than falling back to a sane locale: one
// region-suffixed language took out every currency cell on the screen, not one.
// Region-suffixed tags are not hypothetical — the language detector produces
// them and `src/i18n.ts` only normalises i18next's own copy (`initialized`), so
// anything reading a language off a user or company record can hold one.
//
// A region we recognise as one is kept; anything else is dropped and the bare
// language resolves to its own default region, which is what `sk-SK` / `en-EN`
// resolved to anyway.
function intlLocale(lang: string): string {
    const [primary = '', region = ''] = String(lang || '')
        .trim()
        .split(/[-_]/);
    if (!primary) return 'en';
    return /^([A-Za-z]{2}|\d{3})$/.test(region)
        ? `${primary.toLowerCase()}-${region.toUpperCase()}`
        : primary.toLowerCase();
}

export function formatCurrency(value: string | number, lang: string = 'en', currency: string = 'EUR') {
    const num = parseFloat(String(value));
    if (isNaN(num)) return "-";
    return new Intl.NumberFormat(intlLocale(lang), {
        style: 'currency',
        currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(num);
}
